// extracted by mini-css-extract-plugin
export var benefit_container = "Benefits-module--benefit_container--A8zNf";
export var benefits = "Benefits-module--benefits--e5x3W";
export var benefits_container = "Benefits-module--benefits_container--3gqYc";
export var buttonWrap = "Benefits-module--buttonWrap--Ew0KT";
export var content_container = "Benefits-module--content_container--HuWTU";
export var image_container = "Benefits-module--image_container--R-tyV";
export var page404Title = "Benefits-module--page404-title--PFT1W";